var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileDdImg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4H7.625C7.8125 4 8 4.1875 8 4.375V4.625C8 4.84375 7.8125 5 7.625 5H3.5C3.21875 5 3 5.25 3 5.5V14.5C3 14.7812 3.21875 15 3.5 15H7.625C7.8125 15 8 15.1875 8 15.375V15.625C8 15.8438 7.8125 16 7.625 16H3.5C2.65625 16 2 15.3438 2 14.5V5.5C2 4.6875 2.65625 4 3.5 4ZM12.2188 4.625C12.3438 4.46875 12.5938 4.46875 12.75 4.625L17.875 9.75C18.0312 9.90625 18.0312 10.125 17.875 10.2812L12.75 15.4062C12.5938 15.5625 12.3438 15.5625 12.2188 15.4062L12 15.1875C11.8438 15.0312 11.8438 14.8125 12 14.6562L16.0938 10.5312H7.375C7.15625 10.5312 7 10.375 7 10.1562V9.84375C7 9.65625 7.15625 9.46875 7.375 9.46875H16.0938L11.9688 5.375C11.8438 5.21875 11.8438 5 11.9688 4.84375L12.2188 4.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDdImg5);
export default __webpack_public_path__ + "static/media/profileDDImg5.1b128c6cb0b61e1e9d87458f592d0a80.svg";
export { ForwardRef as ReactComponent };